import ExcelJS from "exceljs";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import ExportMenu from "../../../../../Common/ExportMenu/ExportMenu";
import { formatDateTimeWithoutSec } from "../../../../../Common/helper/helpar";
import { useDailyReportStore } from "../store/useDailyReportStore";

export const ExportDailyReport = () => {
  const { dailyEmployeeAttendance } = useDailyReportStore();
  const downloadExcel = async () => {
    const filters = localStorage.getItem("daily-report-filters");
    const { FromDateTime, ToDateTime } = filters ? JSON.parse(filters) : {};

    // Get current date/time for header
    const currentDate = new Date();
    const formattedDate = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const filterDateRange =
      FromDateTime && ToDateTime
        ? `(${formatDateTimeWithoutSec(
            FromDateTime
          )} to ${formatDateTimeWithoutSec(ToDateTime)})`
        : "";
    const reportTitle = `Daily Report ${filterDateRange}`;
    const generatedText = `Report Generated on: ${formattedDate}, ${formattedTime}`;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Daily Report");

    const boldFont = { bold: true };
    const centerAlignment = {
      horizontal: "center",
      vertical: "middle",
      wrapText: true,
    };

    // --- Header Row 1: Report Title ---
    const headerRow1 = worksheet.addRow([generatedText]);
    worksheet.mergeCells(headerRow1.number, 1, headerRow1.number, 8);
    headerRow1.getCell(1).font = boldFont;
    headerRow1.getCell(1).alignment = centerAlignment;

    // --- Header Row 2: Generated Date/Time ---
    const headerRow2 = worksheet.addRow([reportTitle]);
    worksheet.mergeCells(headerRow2.number, 1, headerRow2.number, 8);
    headerRow2.getCell(1).font = boldFont;
    headerRow2.getCell(1).alignment = centerAlignment;

    // --- Table Header Row ---
    const tableHeaderRow = worksheet.addRow([
      "S.No",
      "EMP ID",
      "Name",
      "Operation",
      "Designation",
      "Location",
      "Punch-In Time",
      "Punch-In Location",
      "Punch-Out Time",
      "Punch-Out Location",
      "Working Hours",
    ]);
    tableHeaderRow.eachCell((cell) => {
      cell.font = boldFont;
      cell.alignment = centerAlignment;
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "F6B1B1" },
      };
    });

    // --- Data Rows ---
    dailyEmployeeAttendance.forEach((item, index) => {
      const row = worksheet.addRow([
        index + 1,
        item.employeeId,
        item.employeeName,
        item.operationName,
        item.designationName,
        item.punchInLocation,
        item.punchInTime,
        item.punchInLocation,
        item.punchOutTime,
        item.punchOutLocation,
        item.workingHours,
      ]);
      row.eachCell((cell) => {
        cell.alignment = centerAlignment;
      });
    });

    // --- Adjust Column Widths ---
    worksheet.columns = [
      { width: 10 }, // S.No
      { width: 20 }, // Zone
      { width: 20 }, // Planned Attendance
      { width: 20 }, // Planned Attendance
      { width: 20 }, // Biometric Attendance
      { width: 20 }, // BA + FA
      { width: 15 }, // Shortfall
      { width: 15 }, // Attendance %
      { width: 20 }, // Biometric Attendance
      { width: 20 }, // Forced Attendance
      { width: 20 }, // BA + FA
    ];

    // --- Save and Download Workbook ---
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "DailyReport.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };
  const downloadPDF = () => {
    const doc = new jsPDF();
    const filters = localStorage.getItem("daily-report-filters");
    const { FromDateTime, ToDateTime } = filters ? JSON.parse(filters) : {};

    const filterDateRange =
      FromDateTime && ToDateTime
        ? `(${formatDateTimeWithoutSec(
            FromDateTime
          )} to ${formatDateTimeWithoutSec(ToDateTime)})`
        : "";
    const reportTitle = `Daily Report ${filterDateRange}`;

    // doc.text("Daily Report", 10, 10);
    doc.text(reportTitle, 10, 20);

    const tableData = dailyEmployeeAttendance.map((item, index) => [
      index + 1,
      item.employeeId,
      item.employeeName,
      item.operationName,
      item.designationName,
      item.punchInLocation,
      item.punchInTime,
      item.punchInLocation,
      item.punchOutTime,
      item.punchOutLocation,
      item.workingHours,
    ]);

    autoTable(doc, {
      head: [
        [
          "S.No",
          "EMP ID",
          "Name",
          "Operation",
          "Designation",
          "Location",
          "Punch-In Time",
          "Punch-In Location",
          "Punch-Out Time",
          "Punch-Out Location",
          "Working Hours",
        ],
      ],
      body: tableData,
      startY: 30,
      theme: "striped",
      headStyles: { fillColor: [246, 177, 177] },
      columnStyles: {
        0: { cellWidth: 8 },  // S.No
        1: { cellWidth: 10 },  // EMP ID
        2: { cellWidth: 10 },  // CI Name
        3: { cellWidth: 15 },  // Operation
        3: { cellWidth: 15 },  // Designation
        4: { cellWidth: 20 },  // Location
        5: { cellWidth: 15 },  // Circle
        6: { cellWidth: 15 },  // Punch-In Time
        7: { cellWidth: 15 },  // Punch-Out Time
        8: { cellWidth: 35 },  // Punch-In Location
        9: { cellWidth: 35 },  // Punch-Out Location
        10: { cellWidth: 15 }, // Working Hours
      },
    });

    doc.save("DailyReport.pdf");
  };

  return (
    <ExportMenu
      items={[
        { label: "Excel", icon: "fa-solid fa-file-excel", onClick: downloadExcel },
        { label: "PDF", icon: "fa-solid fa-file-pdf", onClick: downloadPDF },
      ]}
    />
  );
};
